import { CircularProgress, Box, Typography, Button, Grid, Paper } from '@mui/material';
import { styled } from "@mui/system";

export const CourseCard = styled(Paper)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "180px",
  border: "1px solid #E0E0E0",
});

export const ImageWrapper = styled('div')({
  position: 'relative',
  width: '30%',
  height: '147px',
  margin: '16px 24px 16px 16px',
  overflow: 'hidden',
});

export const CourseImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

export const TagBox = styled('div')({
  position: 'absolute',
  bottom: '8px',  
  left: '8px',      
  backgroundColor: '#528AC0',
  color: '#fff',
  padding: '2px 14px',
  fontSize: '12px',
  fontWeight: 600,
  fontFamily: 'Lexend',
  backgroundImage: 'linear-gradient(to right, #62be9c, #68d5ac)'
});


export const ProgressCircle = ({ progress }) => {
  return (
    <Box position="relative" display="inline-flex" marginRight="20px" marginBottom={'auto'} marginTop={'18px'}>
      <CircularProgress
        variant="determinate"
        value={100}
        size={50}
        thickness={4}
        sx={{ color: '#E0E0E0', position: 'absolute' }}
      />
      <CircularProgress
        variant="determinate"
        value={progress}
        size={50}
        thickness={4}
        sx={{ color: '#528AC0' }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="text.primary"
          fontWeight="bold"
          fontSize="14px"
        >
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
};